<template>
  <div
    :class="['top-progress-bar', !visible && 'top-progress-bar--hidden']"
    :style="{ width: width + '%' }"
  />
</template>

<script>
import { progressState } from '@/utils/top-progress';

export default {
  name: 'TopProgressBar',
  data() {
    return {
      visible: false,
      width: 0,
      tickTimer: null,
      finishTimer: null,
      hideTimer: null,
    };
  },
  computed: {
    pending() {
      return progressState.pending;
    },
  },
  watch: {
    pending(newVal, oldVal) {
      if (newVal > 0 && oldVal === 0) {
        this.start();
      } else if (newVal === 0 && oldVal > 0) {
        this.finish();
      }
    },
  },
  mounted() {
    if (this.$router) {
      this.$router.beforeEach((to, from, next) => {
        this.start();
        next();
      });
      this.$router.afterEach(() => {
        this.scheduleFinish();
      });
      this.$router.onError(() => {
        this.finish();
      });
    }
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    start() {
      this.clearTimers();
      this.visible = true;
      this.width = 8;
      this.$nextTick(() => {
        this.tickTimer = setInterval(() => {
          if (this.width < 85) {
            const step = Math.max(1, (85 - this.width) / 12);
            this.width += step;
          }
        }, 200);
      });
    },
    scheduleFinish() {
      // give pending HTTP calls a tick to register before we finalize
      if (this.finishTimer) clearTimeout(this.finishTimer);
      this.finishTimer = setTimeout(() => {
        if (progressState.pending === 0) this.finish();
      }, 200);
    },
    finish() {
      this.clearTimers();
      if (!this.visible) return;
      this.width = 100;
      this.hideTimer = setTimeout(() => {
        this.visible = false;
        this.width = 0;
      }, 260);
    },
    clearTimers() {
      if (this.tickTimer) { clearInterval(this.tickTimer); this.tickTimer = null; }
      if (this.finishTimer) { clearTimeout(this.finishTimer); this.finishTimer = null; }
      if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null; }
    },
  },
};
</script>

<style>
.top-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 2px;
  background: #1EAB56;
  z-index: 10000;
  transition: width 240ms ease-out, opacity 260ms ease-out;
  box-shadow: 0 0 8px rgba(30, 171, 86, 0.55);
  pointer-events: none;
}

.top-progress-bar--hidden {
  opacity: 0;
}
</style>
